/** True for a non-null, non-array object -- the shape dynamic property access needs proven first. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
